import type { Step } from "react-joyride";

export const monthlyReportListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງລາຍການລາຍງານປະຈໍາເດືອນ. ທ່ານສາມາດກັ່ນຕອງຕາມປີ ເດືອນ ພະແນກ, ເພີ່ມລາຍງານໃໝ່ ຫຼື ເບິ່ງ/ແກ້ໄຂ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="monthly-report-list-toolbar"]',
    content:
      "ກົດ 'ເພີ່ມລາຍງານ' ເພື່ອສ້າງລາຍງານປະຈໍາເດືອນໃໝ່. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="monthly-report-list-filter"]',
    content:
      "ເລືອກປີ, ເດືອນ, ພະແນກ ແລະ ຄົ້ນຫາເພື່ອກັ່ນຕອງລາຍການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="monthly-report-list-table"]',
    content:
      "ຕາຕະລາງລາຍງານປະຈໍາເດືອນ. ກົດເບິ່ງ ຫຼື ດາວໂຫຼດເອກະສານ ຫຼື ແກ້ໄຂ.",
    placement: "top",
  },
];
